import React from 'react';
import statusDraftIcon from '../assets/draftW.svg';
import statusInProgressIcon from '../assets/status-in-progress.svg';
import statusFinishedIcon from '../assets/status-finished.svg';

const statusDraft = { path: statusDraftIcon };
const statusInProgress = { path: statusInProgressIcon };
const statusFinished = { path: statusFinishedIcon };

export const statusCellRenderer = (params: any): JSX.Element => {
    switch (params.data.status) {
        case -1:
            return (
                <div className="flex items-center justify-center m-auto text-white text-medium font-medium uppercase px-1 h-[30px] rounded-[4px] w-fit bg-status-draft">
                    <img
                        src={statusDraft.path}
                        alt="draft icon"
                        className="w-[20px] h-[20px] mr-2"
                    />
                    BROUILLON
                </div>
            );
        case 0:
            return (
                <div className="flex items-center justify-center m-auto text-white text-medium font-medium uppercase px-1 h-[30px] rounded-[4px] w-fit bg-status-finished">
                    <img
                        src={statusFinished.path}
                        alt="in progress icon"
                        className="w-[20px] h-[20px] mr-2"
                    />
                    ARCHIVÉE
                </div>
            );
        case 1:
            return (
                <div className="flex items-center justify-center m-auto text-white text-medium font-medium uppercase px-1 h-[30px] rounded-[4px] w-fit bg-status-in-progress">
                    <img
                        src={statusInProgress.path}
                        alt="in progress icon"
                        className="w-[20px] h-[20px] mr-2"
                    />
                    EN COURS
                </div>
            );
        case 2:
            return (
                <div className="flex items-center justify-center m-auto text-white text-medium font-medium uppercase px-1 h-[30px] rounded-[4px] w-fit bg-status-finished">
                    <img
                        src={statusFinished.path}
                        alt="finished icon"
                        className="w-[20px] h-[20px] mr-2"
                    />
                    TERMINÉE
                </div>
            );
        default:
            return (
                <div className="flex items-center justify-center text-white text-medium font-medium uppercase px-1 h-[30px] rounded-[4px] w-fit bg-status-error">
                    ERREUR
                </div>
            );
    }
};
